<template>
  <div :class="b({ displayType })">
    <ul
      v-if="notifications.length"
      :class="b('messages')"
    >
      <li
        v-for="notification in notifications"
        :key="notification.id"
        :class="b('message')"
      >
        <c-notification
          :notification="notification"
          :display-type="displayType"
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import useNotificationStore from '@/stores/notification';
  import cNotification from '@/components/c-notification.vue';

  /**
   * Container for rendering notifications. See /styleguide/notifications for demo.
   */
  export default {
    name: 'c-notification-container',

    components: {
      cNotification,
    },
    // mixins: [],

    props: {
      /**
       * Sets the display type which defines how the notifications are being rendered.
       *
       * Valid values: `[global, modal]`
       */
      displayType: {
        type: String,
        default: 'global',
        validator(value) {
          return ['global', 'modal'].includes(value);
        },
      },
    },
    setup() {
      return {
        notificationStore: useNotificationStore(),
      };
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Returns an Array of notifications, which should be displayed by this container.
       *
       * @returns {Array.<Object>}
       */
      notifications() {
        switch (this.displayType) {
          case 'global':
            return this.notificationStore.getGlobalNotifications;

          case 'modal':
            return this.notificationStore.getNonSelectorNotifications;

          default:
            return [];
        }
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>

<style lang="scss">
  @use 'sass:math';
  @use 'sass:map';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-notification-container {
    $this: &;

    &--display-type-global {
      width: 100%;
    }

    &__messages {
      @extend %list-reset;
      @include mixins.z-index(globalNotification);

      overflow: hidden;

      #{$this}--display-type-global & {
        position: absolute;
        right: 0;
        width: 100%;
        padding: functions.rem(variables.$spacing--10 0 0 variables.$spacing--25);

        @include mixins.media(sm) {
          width: functions.rem(500px);
          padding-top: variables.$spacing--40;
        }

        @include mixins.media(lg) {
          right: calc(
            50% -
              (
                #{math.div(map.get(variables.$breakpoints, lg), 2)} -
                  #{functions.rem(math.div(variables.$grid-whitespace--lg, 2))}
              )
          );
        }
      }
    }

    &__message {
      margin-bottom: functions.rem(variables.$spacing--5);

      #{$this}--display-type-modal & {
        margin-bottom: 0;
      }
    }
  }
</style>
